"use strict";

exports.arrayExtend = function(f) {
  return function(xs) {
    return xs.map(function (_, i, xs) {
      return f(xs.slice(i));
    });
  };
};



//////////////////
// WEBPACK FOOTER
// ./output/Control.Extend/foreign.js
// module id = 293
// module chunks = 0